module.exports = __webpack_public_path__ + "c48600e1f9f4612c89dafef72cee5dd2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/background_sounds/river.png
// module id = 3158
// module chunks = 0